import type { AgentVerificationLog } from '@percent/admin-dashboard/api/types'

export const mockAgentVerificationLogsResponse: { data: AgentVerificationLog[] } = {
  data: [
    {
      id: 'staging_avlog_XXXXXXXXXXXXXXXXXM',
      agentVerificationId: 'staging_agentverification_XXXXXXXXXXXXXXXXXG',
      type: 'inbox_verification_email_sent',
      createdAt: '2024-04-29T07:48:42.673Z',
      data: {}
    },
    {
      id: 'staging_avlog_XXXXXXXXXXXXXXXXXK',
      agentVerificationId: 'staging_agentverification_XXXXXXXXXXXXXXXXXG',
      type: 'domain_not_matched',
      createdAt: '2024-04-29T07:48:42.578Z',
      data: {}
    },
    {
      id: 'staging_avlog_XXXXXXXXXXXXXXXXXI',
      agentVerificationId: 'staging_agentverification_XXXXXXXXXXXXXXXXXG',
      type: 'email_domain_not_matched',
      createdAt: '2024-04-29T07:48:42.574Z',
      data: {}
    },
    {
      id: 'staging_avlog_XXXXXXXXXXXXXXXXXH',
      agentVerificationId: 'staging_agentverification_XXXXXXXXXXXXXXXXXG',
      type: 'agent_verification_created',
      createdAt: '2024-04-29T07:48:42.377Z',
      data: {}
    }
  ]
}

export const mockAgentVerificationEmailSentLog: AgentVerificationLog = {
  id: 'staging_avlog_XXXXXXXXXXXXXXXXXH',
  agentVerificationId: 'staging_agentverification_XXXXXXXXXXXXXXXXXG',
  type: 'agent_verification_document_request_email_sent',
  createdAt: '2024-04-29T07:48:42.377Z',
  data: {}
}

export const mockAgentVerificationDomainAutoApprovedLog: AgentVerificationLog = {
  id: 'staging_avlog_XXXXXXXXXXXXXXXXXM',
  agentVerificationId: 'staging_agentverification_XXXXXXXXXXXXXXXXXG',
  type: 'domain_auto_verified',
  createdAt: '2024-04-29T07:48:42.673Z',
  data: {}
}

export const mockAgentVerificationOrganisationEmailChangeLog: AgentVerificationLog = {
  id: 'staging_avlog_XXXXXXXXXXXXXXXXXM',
  agentVerificationId: 'staging_agentverification_XXXXXXXXXXXXXXXXXG',
  type: 'organisation_email_change',
  createdAt: '2024-04-29T07:48:42.673Z',
  data: {}
}

export const mockAgentVerificationInboxVerificationEmailSentLog: AgentVerificationLog = {
  id: 'staging_avlog_XXXXXXXXXXXXXXXXXN',
  agentVerificationId: 'staging_agentverification_XXXXXXXXXXXXXXXXXG',
  type: 'inbox_verification_email_sent',
  createdAt: '2024-04-29T07:48:42.673Z',
  data: {}
}

export const mockAgentVerificationKycInitiatedLog: AgentVerificationLog = {
  id: 'staging_avlog_XXXXXXXXXXXXXXXXXO',
  agentVerificationId: 'staging_agentverification_XXXXXXXXXXXXXXXXXG',
  type: 'kyc_verification_initiated',
  createdAt: '2024-04-29T07:48:42.673Z',
  data: {}
}
